// extracted by mini-css-extract-plugin
export default {"statusContainer":"CardTaxWithholdingStatus_statusContainer__0JELA"};